/**
 * Describe your function here
 * @param { * } data - Function input
 * @return { * } - Function response
 */

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

const isValid = entry => !!entry;

const clean = entry => (entry || '');

const work = (entry) => {
  let newEntry = clean(entry);
  newEntry = newEntry.replace(/[\.\,]+/g, '');
  newEntry = newEntry.split(' ').map(e => e.capitalize()).join(' ');

  return {
    value: newEntry == '' ? null : newEntry,
    original: entry,
    valid: isValid(newEntry),
  };
};

export default async (entry, data) =>
// let invalids = data.map(work).filter((e) => !e.valid && e.value != "");
// return [work(entry), invalids]
  work(entry);
